
export default {
  props: {
    imgUrl: {
      type: String,
      required: true,
    },
    gradientStart: {
      type: String,
      default: "rgba(0, 0, 0, 0.5)",
    },
    gradientEnd: {
      type: String,
      default: "rgba(0, 0, 0, 0.5)",
    },
    title: {
      type: String,
      default: null,
    },
    subtitle: {
      type: String,
      default: null,
    },
    btnText: {
      type: String,
      default: null,
    },
    btnLink: {
      type: String,
      default: null,
    },
  },
  methods: {
    signup() {
      if (window.innerWidth < 1024) {
        this.$root.$emit("sign-up-drawer:open");
      } else {
        this.$router.push({ name: "auth-signup" });
      }
    },
  },
};
